// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2281":"463d30b8","7201":"44d7851f"}[chunkId] + ".chunk.css";
};